const TOKEN_KEY = 'blackified_session_token';
const NONCE_KEY = 'blackified_pwa_nonce';

export function saveSessionToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
}

export function getSessionToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function clearSessionToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function savePwaNonce(nonce) {
  localStorage.setItem(NONCE_KEY, nonce);
}

export function getPwaNonce() {
  return localStorage.getItem(NONCE_KEY);
}

export function clearPwaNonce() {
  localStorage.removeItem(NONCE_KEY);
}

/**
 * Fetch wrapper that includes the session token as an Authorization header
 * (fallback for when cookies don't work, e.g. iOS Safari ITP).
 */
export function authFetch(url, options = {}) {
  const token = getSessionToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return fetch(url, {
    ...options,
    headers,
    credentials: 'include',
  });
}
